import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import moment from 'moment';
import { Observable, Subject, Subscription, debounceTime, of } from 'rxjs';
import {
  agentAfiliateAccountant,
  CONFIG_BASE_DATE_RANGEPICKER,
  userActiveAndInactive,
} from '../../../../../../../core/constants/constants';
import { FilterCommunicationService } from '../../../../../../../core/services/filter-communication.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { HolderAccountBankService } from '../../../../../../../core/services/holder-account-bank.service';
import { FinancialService } from '../../../../../../../core/services/financial.service';
import { ChargesWithdrawalsRequestService } from '../../../../../../../core/services/charges-withdrawals-request.service';
import { DynamicModalService } from '../../../../../../../core/services/dynamic-modal.service';
import {
  filterOptions,
  movementType,
} from '../../../../../../../shared/data/suscriptions-payments/constants';
import { StateService } from '../../../../../../../core/services/state.service';
import { ActivatedRoute, Router } from '@angular/router';
import { selectAuth } from '../../../../../../../core/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { selectScreen } from '../../../../../../../core/state/screen/screen.selectors';
import { CountryService } from '../../../../../../../core/services/country.service';
import { ROLES } from '../../../../../../../shared/data/config/constants';
import { UserMainService } from '../../../../../../user/services/user-main.service';
import { USERS_TYPES } from '../../../../../../../shared/data/users/agents/constants';
import { BankOption } from '../../../../../../../core/interfaces/bank.interface';
import { User } from '../../../../../../../core/interfaces/user.interface';
import { UserCreatedRegisterDto } from '../../../../../../../core/interfaces/agent-request.interface';
import {
  SubscriptionPaymentQueryFilters,
  SubscriptionPaymentState,
} from '../../../../../../../core/interfaces/subscription-payment.interface';
import { ReferredAndAgents, Banks } from '../../../../../../accounting/banking/interface/bank-accounts.interface';
import { AccountingAccountSelectOption } from '../../../../../../../core/interfaces/accounting-account.interface';
import { PAYMENTS_BUTTON_PERMISSIONS } from '../../../../../../../shared/data/config/constants-buttons';
import {
  Permission,
  MainPermission,
} from '../../../../../../../core/interfaces/permision.interface';

interface SelectItem<T extends string | number = number> {
  label: string;
  value: T;
}

interface CountryOption {
  pais: string;
  id_pais: number;
}

interface ListSpProfile extends Pick<User, 'idusuario' | 'id_rol'> {
  rol?: {
    permisos_principales: MainPermission[];
  };
}

const ACCOUNT_FILTER_TYPE = 'ACCOUNT';

@Component({
  selector: 'app-list-sp-table-filter',
  templateUrl: './list-sp-table-filter.component.html',
  styleUrl: './list-sp-table-filter.component.scss',
})
export class ListSpTableFilterComponent implements OnInit {
  public listSpFormFilter!: FormGroup;
  public optionsHolder$!: Observable<SelectItem[]>;
  public optionsAgents$!: Observable<SelectItem[]>;
  public optionsBanks$!: Observable<BankOption[]>;
  public allBankData: BankOption[] = [];
  public currentPageBanks = 1;
  public optionsState$!: Observable<SelectItem<number>[]>;
  public optionsCountries$!: Observable<SelectItem<number>[]>;
  public optionsMovementType$!: Observable<SelectItem<string>[]>;
  public createUser$!: Observable<SelectItem[]>;
  public id_country: number | null = null;
  public currentPageAgents = 1;
  public currentPageCreatedBy = 1;
  public currentPageHolders = 1;
  public allAgentsData: SelectItem[] = [];
  public allHoldersData: SelectItem[] = [];
  public allCreatedBy: SelectItem[] = [];
  public pageSize = 10;
  public criteria = '';
  private filterSubject: Subject<string> = new Subject<string>();
  public showFilter: boolean = false;
  public selectedBankId: number | null = null;
  public transformedDataBank: BankOption[] = [];
  public responseCreateUser: SelectItem[] = [];
  public id_agente: number | null = null;
  public isMobile: boolean = false;
  public token!: string;
  public selectedCountryId!: number | null;
  public notCountrySelect: boolean = true;
  public notBankSelect: boolean = true;
  public isAgent = true;
  private filterSubscription = new Subscription();
  public optionsAccountingAccount$!: Observable<
    { label: string; value: number }[]
  >;
  private readonly filterOptionsWithoutAccounts = filterOptions.filter(
    (option) => option.value !== ACCOUNT_FILTER_TYPE,
  );
  public isMainDateDisabled = false;
  //LOGGEDSUSER
  public profile$ = this.store.select(selectAuth);
  public profile: ListSpProfile | null = null;

  //DATE
  public bsConfig = CONFIG_BASE_DATE_RANGEPICKER.bsConfig;
  public initialRange: Date[] = CONFIG_BASE_DATE_RANGEPICKER.initialRange;

  // REDUX
  public isMobile$ = this.store.select(selectScreen);
  public isMobileRedux!: boolean;
  public ROLES = ROLES;
  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _filterCommunicationService: FilterCommunicationService,
    private _holderAccountBank: HolderAccountBankService,
    private _userMainService: UserMainService,
    private cwService: ChargesWithdrawalsRequestService,
    private stateSevice: StateService,
    private router: Router,
    private activedRouter: ActivatedRoute,
    private store: Store,
    private _countryService: CountryService,
    private _financialService: FinancialService,
    private dynamicModal: DynamicModalService
  ) {
    this.initForm();
    this.filterSubject.pipe(debounceTime(400)).subscribe((term: string) => {
      this.allAgentsData = [];
      this.allCreatedBy = [];
      this.allHoldersData = [];
      this.allBankData = [];
      this.loadAgents(term);
      this.getHoldersData(term);
      this.getBankData(term);
    });
  }

  async ngOnInit(): Promise<void> {
    this.subscribeToMobileState();
    this.detectMobileMode();
    this.getAccountingAccountData();
    if (this.isMobile) {
      await this.getUserDataForMobile();
    } else {
      await this.getUserDataForDesktop();
    }

    this.getBankData();
    this.getHoldersData();
    this.getUserCreatedRequestCharge();
    this.getMovementType();
    this.listenToFilterTypeChanges();
    this.getCountries();
    this.getStatesSp();
    this.sendFilter();
    this.syncExternalFilters();
    this.listenToBankDateChanges();
  }

  //MOBILE

  subscribeToMobileState(): void {
    this.isMobile$.subscribe((isMobile) => {
      this.isMobileRedux = isMobile;
    });
  }

  detectMobileMode(): void {
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
  }

  async getUserDataForMobile(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.activedRouter.params.subscribe((params) => {
        this.token = params['token'];
        this._userService.getUserByTokenApp(this.token).subscribe({
          next: (res) => {
            if (res.data.idusuario) {
              this._userService.getUser(res.data.idusuario).subscribe({
                next: (res) => {
                  this.profile = res.data;
                  this.id_agente = this.profile.idusuario;
                  this.listSpFormFilter
                    .get('id_agente')
                    ?.setValue(this.profile.idusuario);
                  resolve();
                },
                error: (err) => {
                  reject(err);
                },
              });
            } else {
              reject(new Error('No user id found'));
            }
          },
          error: (err) => {
            reject(err);
          },
        });
      });
    });
  }

  async getUserDataForDesktop(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.profile$.subscribe({
        next: (res: ListSpProfile) => {
          if (res.idusuario !== -1) {
            this.profile = res;
            if (this.profile.id_rol === ROLES.AGENT) {
              this.listSpFormFilter
                .get('id_agente')
                ?.setValue(this.profile?.idusuario);
            } else {
              this.loadAgents();
            }
            resolve();
          }
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  //?LOAD DATA
  loadAgents(searchTerm?: string): void {
    this._userMainService
      .getAllReferredAndAgents(
        this.currentPageAgents,
        this.pageSize,
        searchTerm,
        this.id_country,
        userActiveAndInactive,
        agentAfiliateAccountant
      )
      .subscribe((response) => {
        const transformedData: SelectItem[] = response.data.map(
          (item: ReferredAndAgents) => ({
            label: item.usuario,
            value: item.idusuario,
          })
        );
        this.optionsAgents$ = of(transformedData);
        this.allAgentsData = [...this.allAgentsData, ...transformedData];
      });
  }
  getUserCreatedRequestCharge(): void {
    this.cwService.getUserCreatedRegister().subscribe((response) => {
      this.responseCreateUser = response.data.map(
        (item: UserCreatedRegisterDto): SelectItem => ({
          label: item.usuario,
          value: item.idusuario,
        })
      );

      this.createUser$ = of(this.responseCreateUser);
    });
  }
  getHoldersData(searchTerm?: string): void {
    this._userService
      .getHolders(this.currentPageHolders, this.pageSize, searchTerm)
      .subscribe((response) => {
        const transformedData: SelectItem[] = response.data.map(
          (item: { usuario: string; idusuario: number }) => ({
            label: item.usuario,
            value: item.idusuario,
          })
        );
        this.optionsHolder$ = of(transformedData);
        this.allHoldersData = [...this.allHoldersData, ...transformedData];
      });
  }

  getBankData(searchTerm?: string): void {
    this._userMainService
      .getAllBanksBySelect(this.currentPageBanks, this.pageSize, searchTerm)
      .subscribe((response) => {
        this.transformedDataBank = response.data.map((item: Banks) => ({
          label: item.bankName,
          value: item.bankId,
        }));
        this.allBankData = [...this.allBankData, ...this.transformedDataBank];
      });
  }
  getMovementType(): void {
    this.optionsMovementType$ = of(movementType);
  }
  getStatesSp(): void {
    this.stateSevice.geatAllDataSp().subscribe((response: { data: SubscriptionPaymentState[] }) => {
      const transformedData: SelectItem<number>[] = response.data.map(
        (item: SubscriptionPaymentState) => ({
          label: item.estado,
          value: item.n_estado,
        })
      );
      this.optionsState$ = of(transformedData);
    });
  }
  getCountries(): void {
    this._countryService.getAllCountries().subscribe((res: { data: CountryOption[] }) => {
      const transformedData: SelectItem<number>[] = res.data.map(
        (item: CountryOption) => ({
          label: item.pais,
          value: item.id_pais,
        })
      );
      this.optionsCountries$ = of(transformedData);
    });
  }

  //*NG-SELECT
  onScrollToEnd(): void {
    this.currentPageAgents++;
    this.loadAgents(this.criteria);
    this.currentPageHolders++;
    this.currentPageBanks++;
    this.getBankData(this.criteria);
    this.getHoldersData(this.criteria);
  }
  onSearch(term: string): void {
    this.criteria = term;
    this.allAgentsData = [];
    this.allCreatedBy = [];
    this.allHoldersData = [];
    this.allBankData = [];
    this.currentPageAgents = 1;
    this.currentPageCreatedBy = 1;
    this.currentPageHolders = 1;
    this.currentPageBanks = 1;
    this.filterSubject.next(term);
  }
  onSearchBank(): void {
    this.selectedBankId = null;
  }

  onBankSelected(event: { value: number }) {
    this.selectedBankId = event.value;
  }

  //*TOGGLE
  toggleChart(): void {
    this.showFilter = !this.showFilter;
  }
  getShowFilterStyle(): { [key: string]: string } {
    return this.showFilter
      ? { overflow: 'visible', maxHeight: '600px' }
      : { overflow: 'hidden', maxHeight: '0' };
  }

  //*FORM
  initForm(): void {
    this.listSpFormFilter = this.fb.group({
      id_agente: [null],
      id_codigo: [null],
      amount: [null],
      receipt: [null],
      movement_type: [null],
      bank: [null],
      holder: [null],
      observation: [null],
      state: [null],
      created_by: [null],
      country: [null],
      dateRange: [this.initialRange],
      bank_date_range: [null],
      filterType: [null],
    });
  }

  listenToBankDateChanges(): void {
    this.listSpFormFilter
      .get('bank_date_range')
      ?.valueChanges.subscribe((value: Date[] | null) => {
        this.updateMainDateState(value);
      });
  }

  updateMainDateState(bankDateRange: Date[] | null): void {
    const dateRangeControl = this.listSpFormFilter.get('dateRange');
    const hasBankDateRange = !!(
      bankDateRange &&
      bankDateRange[0] &&
      bankDateRange[1]
    );

    this.isMainDateDisabled = hasBankDateRange;

    if (hasBankDateRange) {
      dateRangeControl?.disable({ emitEvent: false });
      return;
    }

    dateRangeControl?.enable({ emitEvent: false });
  }

  sendFilter(): void {
    const filterValues = this.listSpFormFilter?.getRawValue() as {
      id_agente: number | null;
      id_codigo: number | null;
      amount: string | number | null;
      receipt: string | null;
      movement_type: string | null;
      bank: number | null;
      holder: number | null;
      observation: string | null;
      state: number | string | null;
      created_by: number | null;
      country: number | null;
      dateRange: Date[] | null;
      bank_date_range: Date[] | null;
      filterType: string | null;
    };
    const dateRange = filterValues?.dateRange;
    const bankDateRange = filterValues?.bank_date_range;
    const hasBankDateRange = !!(
      bankDateRange &&
      bankDateRange[0] &&
      bankDateRange[1]
    );

    const formattedFilter = {
      date_start:
        !hasBankDateRange && dateRange && dateRange[0]
          ? moment(dateRange[0]).format('YYYY-MM-DD 00:00:00')
          : null,
      date_end:
        !hasBankDateRange && dateRange && dateRange[1]
          ? moment(dateRange[1]).format('YYYY-MM-DD 23:59:59')
          : null,
      bank_date_start:
        bankDateRange && bankDateRange[0]
          ? moment(bankDateRange[0]).format('YYYY-MM-DD 00:00:00')
          : null,
      bank_date_end:
        bankDateRange && bankDateRange[1]
          ? moment(bankDateRange[1]).format('YYYY-MM-DD 23:59:59')
          : null,
    };

    const filters: SubscriptionPaymentQueryFilters = {
      id_agente:
        this.isMobile || this.profile?.id_rol === ROLES.AGENT
          ? this.profile?.idusuario
          : filterValues.id_agente,
      id_codigo: this.canViewAccountingAccounts ? filterValues.id_codigo : null,
      holder: filterValues.holder,
      dateRange: hasBankDateRange ? null : dateRange,
      datestart: formattedFilter.date_start,
      dateend: formattedFilter.date_end,
      bank_date_range: bankDateRange,
      bank_date_start: formattedFilter.bank_date_start,
      bank_date_end: formattedFilter.bank_date_end,
      receipt: filterValues.receipt?.trim(),
      amount: filterValues.amount,
      bank: filterValues.bank,
      state: filterValues.state,
      country: filterValues.country,
      movement_type: filterValues.movement_type,
      observation: filterValues.observation,
      created_by: filterValues.created_by,
      filterType:
        !this.canViewAccountingAccounts &&
        filterValues.filterType === ACCOUNT_FILTER_TYPE
          ? null
          : filterValues.filterType,
    };

    this._filterCommunicationService.changeFilter(filters);
  }
  resetForm(): void {
    this.dynamicModal.closeModal();

    this.listSpFormFilter.reset({
      amount: null,
      id_agente:
        this.isMobile || this.profile?.id_rol === ROLES.AGENT
          ? this.profile?.idusuario
          : null,
      holder: null,
      id_codigo: null,
      receipt: null,
      bank: null,
      observation: null,
      created_by: null,
      state: null,
      country: null,
      movement_type: null,
      dateRange: this.initialRange,
      bank_date_range: null,
      filterType: null,
    });

    const clearFilter: SubscriptionPaymentQueryFilters = {
      amount: null,
      id_agente:
        this.isMobile || this.profile?.id_rol === ROLES.AGENT
          ? this.profile?.idusuario
          : null,
      holder: null,
      receipt: null,
      bank: null,
      id_codigo: null,
      observation: null,
      created_by: null,
      state: null,
      country: null,
      movement_type: null,
      dateRange: this.initialRange,
      datestart:
        this.initialRange && this.initialRange[0]
          ? moment(this.initialRange[0]).format('YYYY-MM-DD 00:00:00')
          : null,
      dateend:
        this.initialRange && this.initialRange[1]
          ? moment(this.initialRange[1]).format('YYYY-MM-DD 23:59:59')
          : null,
      bank_date_start: null,
      bank_date_end: null,
      filterType: null,
    };

    this._filterCommunicationService.changeFilter(clearFilter);
  }

  syncExternalFilters(): void {
    this.filterSubscription = this._filterCommunicationService.currentFilter.subscribe(
      (filters: SubscriptionPaymentQueryFilters | null) => {
        if (!filters) return;

        this.listSpFormFilter.patchValue(
          {
            dateRange: filters.dateRange ?? this.initialRange,
            receipt: filters.receipt ?? null,
            amount: filters.amount ?? null,
            bank_date_range: filters.bank_date_range ?? null,
          },
          { emitEvent: false }
        );
        this.updateMainDateState(filters.bank_date_range ?? null);
      }
    );
  }

  //*UTILS
  capitalizeName(name: string): string {
    return name
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  get filterOptions() {
    return this.canViewAccountingAccounts
      ? filterOptions
      : this.filterOptionsWithoutAccounts;
  }

  get canViewAccountingAccounts(): boolean {
    return this.hasPermission(
      PAYMENTS_BUTTON_PERMISSIONS.VIEW_ACCOUNTING_ACCOUNTS,
    );
  }

  hasPermission(permissionId: number): boolean {
    return (
      this.profile?.rol?.permisos_principales?.some(
        (mainPermission: MainPermission) =>
          mainPermission.permisos.some(
            (permission: Permission) => permission.id === permissionId,
          ),
      ) ?? false
    );
  }

  listenToFilterTypeChanges(): void {
    this.listSpFormFilter.get('filterType')?.valueChanges.subscribe((value) => {
      if (value === 'AGENT') {
        this.isAgent = true;
        this.listSpFormFilter.get('id_codigo')?.reset();
      } else if (value === 'ACCOUNT') {
        this.isAgent = false;
        this.listSpFormFilter.get('id_agente')?.reset();
      } else {
        this.isAgent = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.filterSubscription.unsubscribe();
  }

  toggleSwitch(): void {
    const currentControlName = this.isAgent ? 'id_agente' : 'id_codigo';
    const oppositeControlName = this.isAgent ? 'id_codigo' : 'id_agente';

    this.listSpFormFilter.get(currentControlName)?.reset();
    this.listSpFormFilter.get(oppositeControlName)?.setValue(null);

    this.isAgent = !this.isAgent;
  }

  getAccountingAccountData(): void {
    this._financialService
      .getAccountingAccountsForSelect()
      .subscribe((response) => {
        const transformedData = response.data.map((item: AccountingAccountSelectOption) => ({
          label: `${item.code} - ${item.name}`,
          value: item.id,
        }));
        this.optionsAccountingAccount$ = of(transformedData);
      });
  }
}
